import axios from 'axios';
import config from '../../config';
import {
  goTo,
} from '../../actions/routing';
import {
  formatFormData,
} from '../../utils/formData';
import { SERVER_ERROR_CODES } from '../../constants/constants';

export const HIDE_ALERT = 'myaxa/signupLife/HIDE_ALERT';
export const POLICY_SELECTED = 'myaxa/signupLife/POLICY_SELECTED';
export const SUBMIT_INDIVIDUAL_INFO = 'myaxa/signupLife/SUBMIT_INDIVIDUAL_INFO';
export const SUBMIT_INDIVIDUAL_INFO_FAIL = 'myaxa/signupLife/SUBMIT_INDIVIDUAL_INFO_FAIL';
export const HKID_SUBMIT = 'myaxa/signup/HKID_SUBMIT';
export const CHINAID_SUBMIT = 'myaxa/signup/CHINAID_SUBMIT';
export const PASSPORT_SUBMIT = 'myaxa/signup/PASSPORT_SUBMIT';
export const CHANGE_VALUES = 'myaxa/signupLife/CHANGE_VALUES';
const SUBMIT_PENDING = 'myaxa/signupLife/SUBMIT_PENDING';
export const RESEND_LINK = 'myaxa/signupLife/RESEND_LINK';

const initialState = {
  showAlert: false,
  showError: false,
  username: '',
  userData: {},
  hasChangeValues: false,
  serverStatus: '',
  dataCode: '',
  checkDANotExists: false,
  isSubmitting: false,
  errorCode: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case POLICY_SELECTED:
      return {
        ...state,
        policyType: action.policyType,
      };
    case SUBMIT_INDIVIDUAL_INFO:
      return {
        ...state,
        isSubmitSuccessed: true,
        showAlert: !action.hash,
        hash: action.hash,
        emails: action.emails,
        mobiles: action.mobiles,
        isLoading: false,
      };
    case HKID_SUBMIT:
    case CHINAID_SUBMIT:
    case PASSPORT_SUBMIT:
      return {
        ...state,
        isSubmitSuccessed: true,
        isLoading: false,
      };
    case SUBMIT_INDIVIDUAL_INFO_FAIL:
      return {
        ...state,
        hkId: action.hkId,
        chinaId: action.chinaId,
        passport: action.passport,
        onlyCompany: true,
        isLoading: false,
        errorCode: action.errorCode,
        ...action.data,
      };
    case HIDE_ALERT:
      return {
        ...state,
        showAlert: false,
        showError: false,
      };
    case CHANGE_VALUES:
      return {
        ...state,
        hasChangeValues: true,
      };
    case SUBMIT_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case RESEND_LINK:
      return {
        ...state,
        loginId: action.loginId,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const onPolicySelect = (link, policyType) => {
  return async (dispatch) => {
    dispatch({
      type: POLICY_SELECTED,
      policyType,
    });
    dispatch(goTo(link));
  };
};

export function hasChangeValues() {
  return (dispatch) => {
    dispatch({
      type: CHANGE_VALUES,
    });
  };
}

export const onHkIdSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: HKID_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/life/dob`));
  };
};

export const onChinaIdSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: CHINAID_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/life/dob`));
  };
};

export const onPassportSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: PASSPORT_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/life/dob`));
  };
};

export function onSubmitIndividualInfoHandler(userId, userIdType) {
  return async (dispatch, getState) => {
    const details = {
      'policyType': userId.policyType,
      'cardType': userIdType,
      'hkid': userId.hkId,
      'chinaid': userId.chinaId,
      'passport': userId.passport,
      'dob': userId.dob,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SUBMIT_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/customer/search`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(async (response) => {
      // customer record found
      if (!response.data.checkHash) { // CUSEXP1, CUSEXP2
        dispatch({
          type: SUBMIT_INDIVIDUAL_INFO_FAIL,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account-fail`));
      } else if (response.data.iam) {
        if (response.data.iam.status === 'pre-validated') {
          const detailsReactivate = {
            'checkHash': response.data.checkHash,
            'locale': `${getState().language.lang}`,
          };
          const formDataReactivate = formatFormData(detailsReactivate);

          await axios.post(`${config.webview.identityBEUrl}/account/reactivate`, formDataReactivate, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }).then((response2) => {
            dispatch({
              type: RESEND_LINK,
              loginId: response2.data.loginId,
            });
            dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/resend`));
          }).catch((error) => {
            dispatch({
              type: SUBMIT_INDIVIDUAL_INFO_FAIL,
              errorCode: error.response.data.code,
            });
            dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account-fail`));
          });
        } else { // registered already
          dispatch({
            type: SUBMIT_INDIVIDUAL_INFO_FAIL,
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/username-registered`));
        }
      } else if ((Object.keys(response.data.emails).length === 0) && (Object.keys(response.data.mobiles).length === 0)) {
        dispatch({
          type: SUBMIT_INDIVIDUAL_INFO_FAIL,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account-fail`));
      } else {
        dispatch({
          type: SUBMIT_INDIVIDUAL_INFO,
          hash: response.data.checkHash,
          emails: response.data.emails,
          mobiles: response.data.mobiles,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/life/create-account`));
      }
    }).catch((error) => {
      if (error.response) {
        const serverErrorCode = error.response.data.code;
        if (SERVER_ERROR_CODES.includes(serverErrorCode)) { // CUSEXP3, CUSEXP7
          dispatch({
            type: SUBMIT_INDIVIDUAL_INFO_FAIL,
            errorCode: serverErrorCode,
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account-fail`));
        } else {
          // CUSEXP5 - No rights
          dispatch({
            type: SUBMIT_INDIVIDUAL_INFO_FAIL,
            data: {
              showAlert: true,
              error: error.response.data.code,
            },
          });
        }
      } else {
        dispatch({
          type: SUBMIT_INDIVIDUAL_INFO_FAIL,
          data: {
            showAlert: true,
            error: 'NETWORK',
          },
        });
      }
    });
  };
}

export function hideAlert() {
  return (dispatch) => {
    dispatch({
      type: HIDE_ALERT,
    });
  };
}
